import React from 'react'
import { Route, Routes as RouteList, useNavigate, Navigate} from 'react-router-dom'
import { LoginCallback, Security } from '@okta/okta-react'
import { VehicleDetail } from '../apps/fleet-management/components/vehicle-detail/VehicleDetail'
import NotFound from '../components/404'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Layout } from '../components/layout'
import ReservationPage from '../apps/fleet-management/components/reservation'
import { oktaAuth } from '../okta/config'
import { CustomerDetailsPage } from '../apps/customer-details/'
import { Promotions } from '../apps/promotions/Promotions'
import { MapContainer } from '../apps/assets-map'
import { Vestaboard } from '../apps/vestaboard/Vestaboard'
import { CustomerTable } from '../apps/fleet-management/components/customer/CustomerTable'
import { RequiredAuth } from '../okta/SecureRoute'
import {ReservationTable} from '../apps/fleet-management/components/reserved/ReservationTable'
import {Settings} from '../apps/scheduling-tool/settings/Settings'
import {Tasks} from '../apps/scheduling-tool/tasks/Tasks'
import {VehicleMedia} from '../apps/fleet-management/components/vehicle-media/VehicleMedia'
import {VehiclesTable} from '../apps/fleet-management/components/listings-table/VehiclesTable'
import { ErrorBoundary } from 'react-error-boundary'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import { CustomerInfo } from '../apps/customer-details/CustomerInfo'
import { CustomerInvoices } from '../apps/customer-details/Invoices/CustomerInvoicesComponent'
import {CQETab} from '../apps/customer-details/CQE/CQETab'
import SubscriptionMileage from '../apps/customer-details/Mileage/SubscriptionMileage'
import CustomerDocuments from '../apps/customer-details/Documents/CustomerDocuments'
import Insurance from '../apps/customer-details/Insurance/Insurance'

const Routes = () => {
  const navigate = useNavigate()

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true })
  }
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
      <RouteList>
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route path="/" element={<Navigate to="/fleet" replace />} />
        <Route path="/fleet" element={<RequiredAuth />} exact={true}>
          <Route path="" element={<Layout title="Vehicles"><ErrorBoundary fallback={<div>Something went wrong</div>}><VehiclesTable /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/fleet/tasks" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Appointments"><ErrorBoundary fallback={<div>Something went wrong</div>}><Tasks /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/fleet/teamsettings" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Team Settings"><ErrorBoundary fallback={<div>Something went wrong</div>}><Settings /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/fleet/vehiclemedia" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Vehicle Media"><ErrorBoundary fallback={<div>Something went wrong</div>}><VehicleMedia /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/view/:from/:id" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Vehicle Details"><ErrorBoundary fallback={<div>Something went wrong</div>}><VehicleDetail /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/fleet/reservations" element={<RequiredAuth />} exact={true}>
          <Route path="" element={<Layout title="Reservations"><ErrorBoundary fallback={<div>Something went wrong</div>}><ReservationTable /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/reservations/:reservationId" element={<RequiredAuth />} exact={true}>
          <Route path="" element={<Layout title="Reservation"><ErrorBoundary fallback={<div>Something went wrong</div>}><ReservationPage /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/customers" element={<RequiredAuth />} exact={true}>
          <Route path="" element={<Layout title="Customers"><ErrorBoundary fallback={<div>Something went wrong</div>}><CustomerTable /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/customers/:customerId" element={<RequiredAuth />} exact={true}>
          <Route path="" element={<Layout title="Customer Details"><ErrorBoundary fallback={<div>Something went wrong</div>}><CustomerDetailsPage /></ErrorBoundary></Layout>} >
            <Route path="" element={<CustomerInfo />} />
          </Route>
        </Route>
        <Route path="/customers/:customerId/invoices" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Customer Invoices"><ErrorBoundary fallback={<div>Something went wrong</div>}><CustomerDetailsPage /></ErrorBoundary></Layout>} >
            <Route path="" element={<CustomerInvoices />} />
          </Route>
        </Route>
        <Route path="/customers/:customerId/cqe" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Customer Qualification"><ErrorBoundary fallback={<div>Something went wrong</div>}><CustomerDetailsPage /></ErrorBoundary></Layout>} >
            <Route path="" element={<CQETab />} />
          </Route>
        </Route>
        <Route path="/customers/:customerId/mileage" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Subscription Mileage"><ErrorBoundary fallback={<div>Something went wrong</div>}><CustomerDetailsPage /></ErrorBoundary></Layout>} >
            <Route path="" element={<SubscriptionMileage/>} />
          </Route>
        </Route>
        <Route path="/customers/:customerId/documents" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Customer Documents"><ErrorBoundary fallback={<div>Something went wrong</div>}><CustomerDetailsPage /></ErrorBoundary></Layout>} >
            <Route path="" element={<CustomerDocuments />} />
          </Route>
        </Route>
        <Route path="/customers/:customerId/insurance" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Customer Insurance"><ErrorBoundary fallback={<div>Something went wrong</div>}><CustomerDetailsPage /></ErrorBoundary></Layout>} >
            <Route path="" element={<Insurance />} />
          </Route>
        </Route>
        <Route path="/promotions" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Promotions"><ErrorBoundary fallback={<div>Something went wrong</div>}><Promotions /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/assets/inventory" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Map"><ErrorBoundary fallback={<div>Something went wrong</div>}><MapContainer /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="/vestaboard" element={<RequiredAuth />}>
          <Route path="" element={<Layout title="Vestaboard"><ErrorBoundary fallback={<div>Something went wrong</div>}><Vestaboard /></ErrorBoundary></Layout>} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </RouteList>
      </QueryParamProvider>
    </Security>
  )
}
export default Routes
